import { invoke, isTauri } from "@tauri-apps/api/core";
import { listen } from "@tauri-apps/api/event";
// src/index.ts
var allEventListeners = /* @__PURE__ */ new Map();
function invokeHybridAppCommand(cmd, args) {
	throwIfNotHybridApp();
	return invoke(cmd, args);
}
async function addHybridAppEventHandler(event, handler) {
	throwIfNotHybridApp();
	const unlisten = await listen(event, (event) => handler(event.payload));
	let eventListeners = allEventListeners.get(event);
	if (!eventListeners) {
		eventListeners = /* @__PURE__ */ new Map();
		allEventListeners.set(event, eventListeners);
	}
	eventListeners.set(handler, unlisten);
}
function removeHybridAppEventHandler(event, handler) {
	throwIfNotHybridApp();
	const eventListeners = allEventListeners.get(event);
	if (!eventListeners) return;
	const unlisten = eventListeners.get(handler);
	if (!unlisten) return;
	eventListeners.delete(handler);
	if (eventListeners.size === 0) allEventListeners.delete(event);
	unlisten();
}
function clearHybridAppEventHandlers(event) {
	throwIfNotHybridApp();
	const eventListeners = allEventListeners.get(event);
	if (!eventListeners) return;
	for (const [, unlisten] of eventListeners) unlisten();
	allEventListeners.delete(event);
}
function throwIfNotHybridApp() {
	if (!isTauri()) throw new Error("This function is only available in a hybrid app context");
}
export { addHybridAppEventHandler, clearHybridAppEventHandlers, invokeHybridAppCommand, isTauri as isHybridApp, removeHybridAppEventHandler };

//# sourceMappingURL=hybrid-app.js.map